import React, { useEffect, useState } from 'react';
import './FileBrowser.css';
import * as api from 'api.js';
import { useGlobalState } from 'hooks';
import { parseFilelist, parseAnalyticsFile } from 'utils.js';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTrash,
    faFile,
    faFileDownload,
    faArchive,
    faPlus,
    faFileUpload,
} from '@fortawesome/free-solid-svg-icons';
import fileDownload from 'js-file-download';
import { PathLite } from 'components/Path/Path';
import { FileUploadModal, FolderCreateModal } from 'components/FileManager/FileManagerModals';

export function FileBrowser() {
    const [state, dispatch] = useGlobalState();
    const [apiError, setApiError] = useState('');
    const [show, setShow] = useState(false);
    const [itemToBeDeleted, setItemToBeDeleted] = useState('');
    const [itemType, setItemType] = useState('folder');
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [showFolderCreateModal, setShowFolderCreateModal] = useState(false);

    const pathLength = state.currentPath.length;
    let pathLevel = '';

    if (pathLength === 1) {
        pathLevel = 'speed class';
    } else if (pathLength === 2) {
        pathLevel = 'vendor';
    }

    useEffect(() => {
        dispatch.setBusy(true); //*
        if (!state.accessToken) return; //*
        const getFileList = async () => {
            try {
                const fileList = await api.getFileList();
                const fileListObj = parseFilelist(fileList);
                if (state.currentPath.length === 0) {
                    dispatch.setAnalyticsFile(parseAnalyticsFile(fileList));
                    dispatch.setTreeObj(fileListObj);
                } else {
                    dispatch.refreshCurrentFolder(fileListObj);
                    if (!state.rememberSelectedFile) {
                        dispatch.setSelectedFile({ name: null });
                    }
                    dispatch.setRememberSelectedFile(false);
                }
            } catch (error) {
                if (error.response) {
                    setApiError(JSON.stringify(error.response));
                }
            } finally {
                dispatch.setBusy(false);
            }
        };
        getFileList(); //*
    }, [state.refresh, state.accessToken]);

    function handleFolderClick(itemName) {
        let newPath;
        if (itemName === 'UP') {
            state.currentPath.pop();
            newPath = state.currentPath.concat([]);
        } else if (state.currentPath.length > 2) {
            return;
        } else {
            newPath = state.currentPath.concat([itemName]);
        }

        dispatch.setCurrentPath(newPath);
    }

    function handleFileClick(fileObj) {
        dispatch.setSelectedFile(fileObj);
    }

    async function handleAnalyticsFileClick() {
        dispatch.setBusy(true);
        try {
            let response = await api.getAnalyticsFile();
            fileDownload(response, 'analytics.csv');
        } catch (error) {
            if (error.response) {
                setApiError(JSON.stringify(error.response));
            }
        } finally {
            dispatch.setBusy(false);
        }
    }

    async function handleFileDownload(filename) {
        let fileWithPath = fixFolderPath(state.currentPath.join('/')) + filename;

        dispatch.setBusy(true);
        try {
            let response = await api.getFile(fileWithPath);
            fileDownload(response, filename);
        } catch (error) {
            if (error.response) {
                setApiError(JSON.stringify(error.response));
            }
        } finally {
            dispatch.setBusy(false);
        }
    }

    function handleItemRemove(itemname, itemtype = 'folder') {
        setItemType(itemtype);
        setItemToBeDeleted(itemname);
        setShow(true);
    }

    if (apiError) {
        return (
            <>
                <h3>API error:</h3>
                {apiError}
            </>
        );
    }
    return (
        <div className="file_browser_main_cont">
            <div className="browser_main_upper">
                <div className="blue_top_bar">
                    <>
                        <FontAwesomeIcon icon={faArchive} />
                        <PathLite />
                    </>
                </div>
                {state.currentPath.length > 0 && (
                    <FolderItem
                        state={state}
                        icon="&#9650;"
                        handleClick={() => handleFolderClick('UP')}
                    />
                )}
                <div
                    className={
                        state.currentPath.length > 0 && state.currentPath.length < 3
                            ? 'file_browser_folders_cont_full_height_scrollable'
                            : 'file_browser_folders_cont'
                    }
                >
                    {state.currentPath.length < 3 &&
                        state.currentItems.map((item) => (
                            <FolderItem
                                state={state}
                                key={item}
                                name={item}
                                handleClick={handleFolderClick}
                                removeHandler={handleItemRemove}
                            />
                        ))}
                    {state.currentPath.length === 0 && state.analyticsFile && (
                        <AnalyticsFileItem
                            item={state.analyticsFile}
                            handleClick={handleAnalyticsFileClick}
                        />
                    )}
                </div>
                {state.currentPath.length > 2 && (
                    <div className="file_browser_files_cont">
                        {state.currentItems.map((item) => (
                            <FileItem
                                key={item.name}
                                item={item}
                                selected={item.name === state.selectedFile.name ? true : false}
                                handleClick={handleFileClick}
                                removeHandler={handleItemRemove}
                                downloadHandler={handleFileDownload}
                            />
                        ))}
                    </div>
                )}
            </div>
            <div className="browser_main_lower">
                {state.currentPath.length < 3 && (
                    <>
                        {pathLevel && (
                            <>
                                <button
                                    className="styled_button"
                                    type="button"
                                    onClick={() => setShowFolderCreateModal(true)}
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                    &nbsp;ADD NEW {pathLevel.toUpperCase()}
                                </button>
                                <FolderCreateModal
                                    show={showFolderCreateModal}
                                    setShow={setShowFolderCreateModal}
                                    type={pathLevel}
                                />
                            </>
                        )}
                    </>
                )}
                {state.currentPath.length > 2 && (
                    <>
                        <button
                            type="button"
                            className="styled_button"
                            onClick={() => setShowUploadModal(true)}
                        >
                            <FontAwesomeIcon icon={faFileUpload} />
                            &nbsp;ADD NEW BINARY
                        </button>
                        <FileUploadModal show={showUploadModal} setShow={setShowUploadModal} />
                    </>
                )}
            </div>
            <ItemDeleteModal
                show={show}
                setShow={setShow}
                itemName={itemToBeDeleted}
                itemType={itemType}
            />
        </div>
    );
}

function FolderItem({ state, name, handleClick, icon = '', removeHandler }) {
    let folderIsEmpty = true;
    if (state.currentPath.length === 1 && name) {
        if (
            !state.treeObj[state.currentPath[0]][name] || // <-- if name item does not exist, do not try to call isEmpty with undefined parameter
            !isEmpty(state.treeObj[state.currentPath[0]][name])
        ) {
            folderIsEmpty = false;
        }
    } else if (state.currentPath.length === 2 && name) {
        if (
            !state.treeObj[state.currentPath[0]][state.currentPath[1]][name] || // <-- if name item does not exist, do not try to call isEmpty with undefined parameter
            !isEmpty(state.treeObj[state.currentPath[0]][state.currentPath[1]][name])
        ) {
            folderIsEmpty = false;
        }
    }

    return (
        <div className="folder_item_container">
            <div className="folder_item_icon" onClick={() => handleClick(name)}>
                {icon}
            </div>
            <div className="folder_item_name" onClick={() => handleClick(name)}>
                {name}
            </div>
            {state.currentPath.length > 0 && !icon && folderIsEmpty && (
                <div className="folder_item_remove_icon" onClick={() => removeHandler(name)}>
                    <FontAwesomeIcon icon={faTrash} />
                </div>
            )}
        </div>
    );
}

function AnalyticsFileItem({ item, handleClick }) {
    return (
        <div className="file_item_container" onClick={() => handleClick()}>
            <div className="file_item_icon">
                <FontAwesomeIcon icon={faFile} />
            </div>
            <div className="file_item_name">{item.Key}</div>
            <div className="file_item_size">{item.Size}</div>
            <div className="file_item_remove_icon">
                <FontAwesomeIcon icon={faFileDownload} />
            </div>
        </div>
    );
}

function FileItem({ item, selected, handleClick, removeHandler, downloadHandler }) {
    return (
        <div className={selected ? 'selected_file_item' : 'file_item_container'}>
            <div className="file_item_icon" onClick={() => handleClick(item)}>
                <FontAwesomeIcon icon={faFile} />
            </div>
            <div className="file_item_name" onClick={() => handleClick(item)}>
                {item.name}
            </div>
            <div className="file_item_size" onClick={() => handleClick(item)}>
                {item.size}
            </div>
            <div
                className="file_item_remove_icon"
                onClick={() => {
                    handleClick(item);
                    downloadHandler(item.name);
                }}
            >
                <FontAwesomeIcon icon={faFileDownload} />
            </div>
            <div
                className="file_item_remove_icon"
                onClick={() => {
                    handleClick(item);
                    removeHandler(item.name, 'file');
                }}
            >
                <FontAwesomeIcon icon={faTrash} />
            </div>
        </div>
    );
}

export const ItemDeleteModal = ({ show, setShow, itemName, itemType = 'folder' }) => {
    const [state, dispatch] = useGlobalState();
    const [submit, setSubmit] = useState(false);
    // do not join if deleting item from root:
    const itemPath =
        state.currentPath.length === 0
            ? itemName
            : fixFolderPath(state.currentPath.join('/')) + itemName;
    //const itemPath = fixFolderPath(state.currentPath.join('/')) + itemName;

    useEffect(() => {
        if (!submit) return;
        dispatch.setBusy(true);
        const deleteItem = async () => {
            try {
                if (itemType === 'folder') {
                    await api.deleteFolder(itemPath);
                } else {
                    await api.deleteFile(itemPath);
                }

                cleanUp();
                dispatch.refreshFileBrowser();
            } catch (error) {
                if (error.response) {
                    console.log(JSON.stringify(error.response));
                }
            } finally {
                dispatch.setBusy(false);
            }
        };
        deleteItem();
    }, [submit]);

    const cleanUp = () => {
        setShow(false);
        setSubmit(false);
    };

    return (
        <div>
            <Modal show={show}>
                <Modal.Header>
                    Remove {itemType === 'folder' ? 'folder' : 'file'} {itemName}?
                </Modal.Header>
                <Modal.Body></Modal.Body>
                <Modal.Footer>
                    <button className="styled_button" onClick={cleanUp}>
                        Cancel
                    </button>
                    <button className="styled_button" onClick={() => setSubmit(true)}>
                        Remove {itemType === 'folder' ? 'folder' : 'file'}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

function fixFolderPath(path) {
    if (path.match(/.*\/$/)) {
        return path;
    }
    return path + '/';
}

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
